import {Platform} from "react-native";

const isWeb = Platform.OS === "web";

// Font families
export const inter = isWeb ? "Inter-Regular, sans-serif" : "Inter-Regular";
export const interMedium = isWeb ? "Inter-Medium, sans-serif" : "Inter-Medium";
export const interSemiBold = isWeb ? "Inter-SemiBold, sans-serif" : "Inter-SemiBold";
